// extracted by mini-css-extract-plugin
export default {"colorMain":"#208399","colorLight":"#71b7c7","rootBackground":"#f0f0f1"};